<!-- Section Mesures Pompe à chaleur -->
<app-collapse [title]="'P00061.status.mesure.pac' | translate">
  <div slot="contenu">
    <app-display-rubrique-status
      [title]="'P00061.status.etatpac' | translate"
      [value]="
        getValue('wpSOnOff') === 1
          ? ('P00061.status.state.pac.fonctionnement' | translate)
          : ('P00061.status.state.pac.veille' | translate)
      "
    />

    <app-display-rubrique-status-on-off
      [title]="'P00061.status.degel' | translate"
      [value]="getValue('wpSDefautsPrincipauxDefrosting') !== 0"
    />

    <app-display-rubrique-status-on-off
      [title]="'P00061.status.compresseur' | translate"
      [value]="getValue('wpSFonctionnementPACCompresseur') !== 0"
    />

    <app-display-rubrique-status-on-off
      [title]="'P00061.status.ventilation.highspeed' | translate"
      [value]="getValue('wpSFonctionnementPACVentilationHauteVitesse') !== 0"
    />

    <app-display-rubrique-status-on-off
      [title]="'P00061.status.ventilation.lowspeed' | translate"
      [value]="getValue('wpSFonctionnementPACVentilationFaibleVitesse') !== 0"
    />

    <app-display-rubrique-status-on-off
      [title]="'P00061.status.pilotage.pompe' | translate"
      [value]="getValue('wpSFonctionnementPACPilotagePompeCirculation') !== 0"
    />

    <app-display-rubrique-status-on-off
      [title]="'P00061.status.vanne' | translate"
      [value]="getValue('wpSFonctionnementPACPilotageVanne4Voies') !== 0"
    />

    <app-display-rubrique-status
      [title]="'P00061.status.temperature.eau.entrante' | translate"
      [value]="getTemperature(getValue('wpSTemperatureEauEntrante') / 10, 1)"
    />

    <app-display-rubrique-status
      [title]="'P00061.status.temperature.eau.sortante' | translate"
      [value]="getTemperature(getValue('wpSTemperatureEauSortante') / 10, 1)"
    />

    <app-display-rubrique-status
      [title]="'P00061.status.temperature.ambiante' | translate"
      [value]="getTemperature(getValue('wpSTemperatureAmbiante') / 10, 1)"
    />

    <app-display-rubrique-status
      [title]="'P00061.status.temperature.evaporateur.in' | translate"
      [value]="
        getTemperature(getValue('wpSTemperatureEntreeEvaporateur') / 10, 1)
      "
    />

    <app-display-rubrique-status
      [title]="'P00061.status.temperature.compresseur.int' | translate"
      [value]="
        getTemperature(getValue('wpSTemperatureEntreeCompresseur') / 10, 1)
      "
    />

    <app-display-rubrique-status
      [title]="'P00061.status.temperature.compresseur.out' | translate"
      [value]="
        getTemperature(getValue('wpSTemperatureSortieCompresseur') / 10, 1)
      "
    />

    <app-display-rubrique-status
      [title]="'P00061.status.pression' | translate"
      [value]="getValue('wpSPression') / 10 + ' bar'"
    />

    <app-display-rubrique-status
      [title]="'P00061.status.frequence' | translate"
      [value]="getValue('wpSFrequenceCompresseur') + ' Hz'"
    />

    <app-display-rubrique-status
      [title]="'P00061.status.ventilateur' | translate"
      [value]="getValue('wpSVitesseVentilateurPrincipal') + ' tr/min'"
    />

    <app-display-rubrique-status
      [title]="'P00061.status.tensionsecteur' | translate"
      [value]="getValue('wpSTensionSecteur') + ' V'"
    />

    <app-display-rubrique-status
      [title]="'P00061.status.courant' | translate"
      [value]="getValue('wpSCourantConsomme') / 10 + ' A'"
    />

    <app-display-rubrique-status
      [title]="'P00061.status.puissance' | translate"
      [value]="getPuissanceCalculee()"
    />

    <app-display-rubrique-status
      [title]="'P00061.status.temperature.cold' | translate"
      [value]="
        getTemperature(getValue('wpSTemperatureConsigneModeFroid') / 10, 1)
      "
    />

    <app-display-rubrique-status
      [title]="'P00061.status.temperature.hot' | translate"
      [value]="
        getTemperature(getValue('wpSTemperatureConsigneModeChaud') / 10, 1)
      "
    />

    <app-display-rubrique-status
      [title]="'P00061.status.temperature.auto' | translate"
      [value]="
        getTemperature(getValue('wpSTemperatureConsigneModeAuto') / 10, 1)
      "
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P00061.status.switches' | translate"
        [value]="getSwitchesHexa()"
      />
    }
  </div>
</app-collapse>

<!-- Section Codes défauts Pompe à chaleur -->
<app-collapse
  [title]="'P00061.status.code.default' | translate"
  [warning]="codeDefautHasWarning"
>
  <div slot="contenu">
    <app-display-rubrique-status
      [title]="'P00061.status.code.default.reglage.debit' | translate"
      [value]="getBypassPacValue()"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.default.temperature.entree' | translate"
      [warning]="getValue('wpSDefautsPrincipauxCodeP01') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.default.temperature.sortie' | translate"
      [warning]="getValue('wpSDefautsPrincipauxCodeP02') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.default.temperature.ambiante' | translate"
      [warning]="getValue('wpSDefautsPrincipauxCodeP04') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.default.temperature.evaporateur' | translate"
      [warning]="getValue('wpSDefautsPrincipauxCodeP05') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="
        'P00061.status.code.default.temperature.compresseur.aspiration'
          | translate
      "
      [warning]="getValue('wpSDefautsPrincipauxCodeP07') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="
        'P00061.status.code.default.temperature.compresseur.echappement'
          | translate
      "
      [warning]="getValue('wpSDefautsPrincipauxCodeP081') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="
        'P00061.status.code.default.compresseur.surintensite' | translate
      "
      [warning]="getValue('wpSDefautsPrincipauxCodeE051') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.default.pression.high' | translate"
      [warning]="getValue('wpSDefautsPrincipauxCodeE01') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.default.pression.low' | translate"
      [warning]="getValue('wpSDefautsPrincipauxCodeE02') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.default.debiteau' | translate"
      [warning]="getValue('wpSDefautsPrincipauxCodeE03') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.default.antigel.primaire' | translate"
      [warning]="getValue('wpSDefautsPrincipauxCodeE19') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.default.antigel.secondaire' | translate"
      [warning]="getValue('wpSDefautsPrincipauxCodeE29') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.default.antigel' | translate"
      [warning]="getValue('wpSDefautsPrincipauxCodeE07') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.default.temperature.decharge' | translate"
      [warning]="
        getValue('wpSRegistreDefauts2HighDischargeTemperatureProtection') === 1
      "
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.default.temperature.difference' | translate"
      [warning]="getValue('wpSDefautsPrincipauxCodeE06') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status
      [title]="'P00061.status.code.default.2' | translate"
      [value]="getRegistreDefauts2Hexa()"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.default.2' | translate"
      [warning]="registreDefauts2HasWarning"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.f02' | translate"
      [warning]="getValue('wpSRegistreDefauts2ConverterBoardOffline') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.f03' | translate"
      [warning]="getValue('wpSRegistreDefauts2IPMProtection') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.codeP00061.status.code.f04' | translate"
      [warning]="getValue('wpSRegistreDefauts2CompressorStartFailure') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.f17' | translate"
      [warning]="getValue('wpSRegistreDefauts2ConverterInputLostPhase') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.f18' | translate"
      [warning]="getValue('wpSRegistreDefauts2IPMSamplingCurrentFailure') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.f20' | translate"
      [warning]="
        getValue('wpSRegistreDefauts2ConverterOverheatProtection') === 1
      "
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.f07' | translate"
      [warning]="getValue('wpSRegistreDefauts2ConverterDCOverVoltage') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.f08' | translate"
      [warning]="getValue('wpSRegistreDefauts2ConverterDCUnderVoltage') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status
      [title]="'P00061.status.code.defaut.3' | translate"
      [value]="getRegistreDefauts3Hexa()"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.defaut.3' | translate"
      [warning]="registreDefauts3HasWarning"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.f12' | translate"
      [warning]="getValue('wpSRegistreDefauts3DspPfcConnectionFailure') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.f19' | translate"
      [warning]="
        getValue('wpSRegistreDefauts3RadiatorTemperatureSensingFailure') === 1
      "
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.f28' | translate"
      [warning]="getValue('wpSRegistreDefauts3OverUnderVoltageFailure') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.f27' | translate"
      [warning]="getValue('wpSRegistreDefauts3PfcFailure') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.f15' | translate"
      [warning]="getValue('wpSRegistreDefauts3IpmOverheatProtection') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.f16' | translate"
      [warning]="getValue('wpSRegistreDefauts3WeakMagneticProtection') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.f24' | translate"
      [warning]="getValue('wpSRegistreDefauts3InputOverCurrentWarning') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.f22' | translate"
      [warning]="getValue('wpSRegistreDefauts3ConverterOverheatWarning') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.f25' | translate"
      [warning]="getValue('wpSRegistreDefauts3EepromErrorWarning') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.f26' | translate"
      [warning]="getValue('wpSRegistreDefauts3InputCoverCurrent') === 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.code.4' | translate"
      [warning]="getRegistreDefauts4Hexa() !== '0000'"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status
      [title]="'P00061.status.code.4' | translate"
      [value]="getRegistreDefauts4Hexa()"
    />
  </div>
</app-collapse>

<!-- Section Identification de la PAC -->
<app-collapse [title]="'P00061.status.identification' | translate">
  <div slot="contenu">
    <app-display-rubrique-status
      [title]="'P00061.status.identification.wfcode' | translate"
      [value]="additionalData?.wpWfCode ? additionalData!.wpWfCode! : '-'"
    />

    <app-display-rubrique-status
      [title]="'P00061.status.identification.serialnumber' | translate"
      [value]="
        additionalData?.wpSerialNumber ? additionalData!.wpSerialNumber! : '-'
      "
    />
  </div>
</app-collapse>

<!-- Section Fonctionnement -->
@if (isSupportTechnique()) {
  <app-collapse [title]="'P00061.status.fonctionnement' | translate">
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P00061.status.fonctionnement.temperaturefcthorloge' | translate
        "
        [value]="getTemperatureFctHorloge()"
      />

      <app-display-rubrique-status-on-off
        [title]="'P00061.status.fonctionnement.prioritepac' | translate"
        [value]="getValue('wpSMiseRouteFiltrationPriorite') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="'P00061.status.fonctionnement.automaintient' | translate"
        [value]="getValue('wpSMiseRouteFiltrationAutoMaintien') !== 0"
      />

      <app-display-rubrique-status
        [title]="'P00061.status.fonctionnement.etatvolet' | translate"
        [value]="
          getValue('wpSEtatVolet') === 0
            ? ('P00061.status.fonctionnement.etatvolet.ouvert' | translate)
            : ('P00061.status.fonctionnement.etatvolet.ferme' | translate)
        "
      />

      <app-display-rubrique-status
        [title]="'P00061.status.fonctionnement.resetusine' | translate"
        [value]="getValue('wpSCompteurResetUsine') + ''"
      />
    </div>
  </app-collapse>
}

<!-- Section Produit passerelle -->
<app-collapse
  [title]="'P00061.status.passerelle' | translate"
  [warning]="produitP00061 !== 1"
>
  <div slot="contenu">
    <app-display-rubrique-status-with-warning
      [title]="'P00061.status.passerelle.connexion' | translate"
      [warning]="produitP00061 !== 1"
      [icon]="'fa-exclamation-triangle'"
      text="OK"
    />

    <app-display-rubrique-status
      [title]="'P00061.status.passerelle.dureetension' | translate"
      [value]="transformHourToDayHourLocal(getValue('wpSTempsSousTension'))"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status-on-off
        [title]="'P00061.status.passerelle.etatbouton' | translate"
        [value]="getValue('wpSEtatBouton') !== 0"
      />

      <app-display-rubrique-status
        [title]="'P00061.status.passerelle.compteurbouton' | translate"
        [value]="
          getValue('wpSCompteurBouton')
            ? getValue('wpSCompteurBouton') + ''
            : '0'
        "
      />
    }
  </div>
</app-collapse>
